module.exports = __webpack_public_path__ + "img/img8.ada06110.svg";